var map = {
	"./Apple.svg": 480,
	"./Bacon.svg": 481,
	"./Banana.svg": 482,
	"./Bread.svg": 483,
	"./Breakfast.svg": 484,
	"./Brocolli.svg": 485,
	"./Burger.svg": 486,
	"./Burrito.svg": 487,
	"./Cabbage.svg": 488,
	"./Cake.svg": 489,
	"./Can.svg": 490,
	"./Candy.svg": 491,
	"./Carrot.svg": 492,
	"./Cheese.svg": 493,
	"./Cherry.svg": 494,
	"./Chicken.svg": 495,
	"./Chinese.svg": 496,
	"./Chips.svg": 497,
	"./Chocolate.svg": 498,
	"./Clams.svg": 499,
	"./Coffee.svg": 500,
	"./Cookie.svg": 501,
	"./Corn.svg": 502,
	"./Cream.svg": 503,
	"./Cucumber.svg": 504,
	"./Cupcake.svg": 505,
	"./Dessert.svg": 506,
	"./Dog.svg": 507,
	"./Donut.svg": 508,
	"./Drink.svg": 509,
	"./Egg.svg": 510,
	"./Eggplant.svg": 511,
	"./Fish.svg": 512,
	"./Fries.svg": 513,
	"./Garlic.svg": 514,
	"./Grape.svg": 515,
	"./Grapefruit.svg": 516,
	"./Green.svg": 517,
	"./Honey.svg": 518,
	"./Jelly.svg": 519,
	"./Kiwi.svg": 520,
	"./Lemon.svg": 521,
	"./Lemonade.svg": 522,
	"./Lobster.svg": 523,
	"./Milk.svg": 524,
	"./Octopus.svg": 525,
	"./Olive.svg": 526,
	"./Onion.svg": 527,
	"./Orange.svg": 528,
	"./Other.svg": 529,
	"./Pancake.svg": 530,
	"./Pastry.svg": 531,
	"./Pea.svg": 532,
	"./Peach.svg": 533,
	"./Peanut.svg": 534,
	"./Pear.svg": 535,
	"./Pepper.svg": 536,
	"./Pie.svg": 537,
	"./Pineapple.svg": 538,
	"./Pitcher.svg": 539,
	"./Pizza.svg": 540,
	"./Plum.svg": 541,
	"./Popsicle.svg": 542,
	"./Potato.svg": 543,
	"./Pretzel.svg": 544,
	"./Pumpkin.svg": 545,
	"./Radish.svg": 546,
	"./Ribs.svg": 547,
	"./Rice.svg": 548,
	"./Salad.svg": 549,
	"./Salmon.svg": 550,
	"./Sandwich.svg": 551,
	"./Sausage.svg": 552,
	"./Shrimp.svg": 553,
	"./Smoothie.svg": 554,
	"./Soda.svg": 555,
	"./Spicy.svg": 556,
	"./Steak.svg": 557,
	"./Strawberry.svg": 558,
	"./Sub.svg": 559,
	"./Sushi.svg": 560,
	"./Taco.svg": 561,
	"./Tea.svg": 562,
	"./Toast.svg": 563,
	"./Tomato.svg": 564,
	"./Turkey.svg": 565,
	"./Waffle.svg": 566,
	"./Watermelon.svg": 567
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 244;